<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama", "AltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      RiskDegerler: [],
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi: [],
      EskiDonemBitTarih: null,
      IlkDonem: false,
      EskiDonem: [],
      donem_yili: "",
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId() {
      this.Get();
    },
  },

  methods: {
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.EskiDonem = [];
      this.ActionsSingleGet({
        Service: "strperfdonem",
        Id: this.AltDonemId,
      }).then((res) => {
        this.EskiDonemBitTarih = (res.Data.YilBit - 1).toString();

        let Filter =
          "&UstId=" +
          this.DonemId +
          "&Approval=true&Asc=Aciklama" +
          "&Yilbit=" +
          this.EskiDonemBitTarih +
          "&VeriTipi=3";
        this.ActionsFilterGet({
          Service: "StrPerfDonem",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          this.EskiDonem = res.Data;
          if (res.Data.length > 0) {
            this.IlkDonem = false;
            this.TabloGet();
          } else {
            this.IlkDonem = true;
            this.TabloGet();
          }
        });
      });
    },
    TabloGet() {
      this.bugun = new Date();
      this.RiskDegerler = [];

      let Filter =
        "&Donemid=" + this.DonemId + "&Gerceklesmedonemid=" + this.AltDonemId;

      if (this.BirimId != null && this.BirimId != "") {
        Filter = Filter + "&BirimId=" + this.BirimId;
      }
      if (this.IlkDonem != true) {
        Filter = Filter + "&OncekiDonemId=" + this.EskiDonem[0].Id;
      }

      this.ActionsFilterGet({
        Service: "StrRaporlama/GetKurumsalRiskRaporu",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.RiskDegerler = res.Data;
        console.log(this.RiskDegerler);
        this.RiskDegerler.sort(this.buyuktenKucugeSiralama);
      });
    },

    buyuktenKucugeSiralama(a, b) {
      return b.Etki * b.Olasilik - a.Etki * a.Olasilik;
    },
    Bol(Data) {
      if (Data != null) {
        let metinDizisi = Data.split("/ ")
          .map((x) => x.trim())
          .filter((x) => x.length > 0);

        metinDizisi.sort((a, b) => {
          const regex = /^\d+/;

          const numA = a.match(regex) ? parseInt(a.match(regex)[0], 10) : null;
          const numB = b.match(regex) ? parseInt(b.match(regex)[0], 10) : null;

          if (numA !== null && numB !== null) {
            // İkisi de sayılıysa, sayıya göre sırala
            return numA - numB;
          } else if (numA !== null) {
            // A sayılı, B değilse; sayılı olan önce gelsin
            return -1;
          } else if (numB !== null) {
            // B sayılı, A değilse
            return 1;
          } else {
            // İkisi de sayısızsa alfabetik sırala
            return a.localeCompare(b, "tr", { sensitivity: "base" });
          }
        });

        return metinDizisi;
      } else {
        return [];
      }
    },

    renk(Data) {
      if (Data > 0 && Data < 26) {
        return "green";
      }
      if (Data >= 26 && Data < 65) {
        return "yellow";
      }
      if (Data >= 65) {
        return "red";
      }
      return "white"; // Varsayılan renk
    },
  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
    <div class="text-sm-end">
      <button
        type="button"
        class="btn btn-success btn-rounded mb-2 me-2"
        @click="ExcelExport('Risk Kayıt Formu', 'Risk Kayıt Formu')"
      >
        <i class="mdi mdi-file-export-outline me-1"></i>
        Excel'e Aktar
      </button>
    </div>

    <div ref="ExcelExportTable" class="table-responsive">
      <div class="table-responsive">
        <table style="width:100%">
          <tr>
            <td colspan="13" style="text-align: center;">
              <div><h4>Risk Kayıt Formu</h4></div>
            </td>
          </tr>
          <tr>
            <td>İdare/Birim/Alt Birim:</td>
            <td colspan="24" style="text-align: right;">
              {{ bugun | formatDateTable }}
            </td>
          </tr>
        </table>

        <br />

        <table
          style="border: 1px solid; border-collapse: collapse; "
          border="1"
          class="table  table-md table-bordered border-success mb-0"
        >
          <thead class="table-light" style="text-align: center;">
            <tr style="text-align: center; font-weight: bold;">
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>4</th>
              <th colspan="2">5</th>
              <th colspan="2">6</th>
              <th>7</th>
              <th>8</th>
              <th>9</th>
              <th>10</th>
              <th colspan="2">11</th>
              <th>12</th>
              <th>13</th>
              <th>14</th>
            </tr>

            <tr style="text-align: center; font-weight: bold;">
              <th class="dikey_yazi">Sıra</th>
              <th class="dikey_yazi">Referans No</th>
              <th class="dikey_yazi">Stratejik Hedef</th>
              <th class="dikey_yazi">Birim / Alt Birim Hedefi</th>
              <th>Tespit Edilen Risk</th>
              <th>Risk Sebepleri</th>
              <th>Riske Verilen Cevaplar</th>
              <th>Mevcut Kontroller</th>
              <th class="dikey_yazi">Etki</th>
              <th class="dikey_yazi">Olasılık</th>
              <th class="dikey_yazi">Risk Puanı (R)</th>
              <th class="dikey_yazi">Değişim (Riskin Yönü)</th>
              <th>Riske Verilecek Cevaplar</th>
              <!--Önceki dönemden aktarılan eylemler-->
              <th>Yeni/Ek/Kaldırılan Kontroller</th>
              <th class="dikey_yazi">Başlangıç Tarihi</th>
              <th>Riskin Sahibi</th>
              <th>Açıklamalar</th>
            </tr>
          </thead>
          <tbody v-for="(Data, index) in RiskDegerler" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{ Data.referansno }}</td>
              <td>{{ Data.Stratejik_hedef }}</td>
              <td>{{ Data.Birim_hedefi }}</td>
              <td>{{ Data.Tespit_edilen_risk }}</td>
              <td>{{ Data.Sebepler }}</td>
              <td>{{ Data.riskin_durumu }}</td>
              <td>
                <span v-if="Data.Kontrolturu == 2">Yönlendirici Kontrol</span
                ><span v-if="Data.Kontrolturu == 3">Önleyici Kontrol</span
                ><span v-if="Data.Kontrolturu == 4">Düzeltici Kontrol</span
                ><span v-if="Data.Kontrolturu == 5">Tespit Edici Kontrol</span>
              </td>
              <td>{{ Math.round(Data.Etki) }}</td>
              <td>{{ Math.round(Data.Olasilik) }}</td>
              <td
                class="text-center"
                :style="{
                  background: renk(
                    Math.round(
                      Math.round(Data.Etki) * Math.round(Data.Olasilik)
                    )
                  ),
                }"
              >
                <span style="color: black">{{
                  Math.round(Data.Etki) * Math.round(Data.Olasilik)
                }}</span>
              </td>
              <td>
                <span
                  v-if="
                    Data.Bironcekidonempuan >
                      Math.round(
                        Math.round(Data.Etki) * Math.round(Data.Olasilik)
                      )
                  "
                >
                  <i
                    class="bx bx-down-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </span>
                <span
                  v-if="
                    Data.Bironcekidonempuan <
                      Math.round(
                        Math.round(Data.Etki) * Math.round(Data.Olasilik)
                      )
                  "
                >
                  <i
                    class="bx bx-up-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i
                ></span>
                <span
                  v-if="
                    Data.Bironcekidonempuan ==
                      Math.round(
                        Math.round(Data.Etki) * Math.round(Data.Olasilik)
                      )
                  "
                  ><i></i
                ></span>
              </td>
              <td>
                <ul
                  v-for="(Data2, index) in Bol(
                    Data.Oncekidonemdengeleneylemler
                  )"
                  :key="index"
                >
                  <li>{{ Data2 }}</li>
                </ul>
              </td>

              <td>
                <!-- Eklenen Eylemler -->
                <template v-if="Data.risk_eklenen_cevaplar != null">
                  <template
                    v-if="
                      Bol(Data.risk_eklenen_cevaplar).filter(
                        (item) =>
                          !Bol(Data.Oncekidonemdengeleneylemler).includes(item)
                      ).length > 0
                    "
                  >
                    <span>
                      Eklenen Eylemler: <br />
                      <ul
                        v-for="(Data2, index) in Bol(
                          Data.risk_eklenen_cevaplar
                        ).filter(
                          (item) =>
                            !Bol(Data.Oncekidonemdengeleneylemler).includes(
                              item
                            )
                        )"
                        :key="index"
                      >
                        <li>{{ Data2 }}</li>
                      </ul>
                    </span>
                  </template>
                </template>

                <!-- Kaldırılan Eylemler -->
                <template v-if="Data.risk_kaldirilan_cevaplar != null">
                  <template
                    v-if="
                      Bol(Data.risk_kaldirilan_cevaplar)
                        .filter((value, i, arr) => arr.indexOf(value) === i)
                        .filter(
                          (item) =>
                            !Bol(Data.Oncekidonemdengeleneylemler).includes(
                              item
                            ) && !Bol(Data.risk_eklenen_cevaplar).includes(item)
                        ).length > 0
                    "
                  >
                    <span>
                      Kaldırılan Eylemler: <br />
                      <ul
                        v-for="(Data2, index) in Bol(
                          Data.risk_kaldirilan_cevaplar
                        )
                          .filter((value, i, arr) => arr.indexOf(value) === i)
                          .filter(
                            (item) =>
                              !Bol(Data.Oncekidonemdengeleneylemler).includes(
                                item
                              ) &&
                              !Bol(Data.risk_eklenen_cevaplar).includes(item)
                          )"
                        :key="index"
                      >
                        <li>{{ Data2 }}</li>
                      </ul>
                    </span>
                  </template>
                </template>
              </td>

              <td>{{ Data.Baslangic_tarihi | formatDateTable }}</td>
              <td>{{ Data.Riskinsahibi }}</td>
              <td>{{ Data.Aciklama }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style type="text/css">
.dikey_yazi {
  writing-mode: vertical-rl;
}
</style>
